module.exports = __webpack_public_path__ + "static/media/InfiniteDoors.2f85661f.ogg";